/* eslint-disable eqeqeq */
import React, { useRef, useState } from "react";
import { useReactToPrint } from "react-to-print";
import { Button } from "../../components/ui/button";
import { ResponsiveDrawerForm } from "../../components/ResponsiveDrawerForm";
import {
  formatDollarCents,
  formatNumber,
  formatSubcontractorName,
  getModuleNamingBySlug,
} from "../../lib/Misc";
import { paymentMethods } from "../../config";
import { useTrust } from "../../lib/context/TrustContext";
// import { useOrganization } from "../../lib/context/OrganisationContext";
import HtmlContent from "../../components/HTMLContent";
import { useOrganization } from "../../lib/context/OrganisationContext";
import { LawyerConditon } from "../../lib/PermissionConditions";
import { Switch } from "../../components/ui/switch";
import { Label } from "../../components/ui/label";
import CustomLabelText from "../../components/CustomLabelText";
import { Checkbox } from "../../components/ui/checkbox";
import CustomTooltip from "../../components/CustomTooltip";
import { InfoCircledIcon } from "@radix-ui/react-icons";
import { DisplayInput } from "../../components/DisplayInput";

const ReceiptDetailsPopup = ({
  showView,
  setShowView,
  data,
  popupType = "",
  value = "",
  type = "1",
}) => {
  const { organizationData } = useOrganization();
  let values = data;

  const printRef = useRef(null);
  const { trustData } = useTrust();
  const [compact, setCompact] = useState(true);
  // const { organizationData } = useOrganization();

  const handlePrint = useReactToPrint({
    content: () => printRef.current,
    contentRef: printRef,
    documentTitle: "Trust Receipt",
    removeAfterPrint: false, // Optional: prevents issues with disappearing modals
  });

  const { dollars, cents } = formatDollarCents(data?.amount ? data?.amount : 0);

  const htmlData = (original) => {
    return type === "1" ? (
      <table className="w-full border-separate border-spacing-y-2">
        <thead>
          <tr>
            <td className="text-blue-600 text-xs font-bold">
              {trustData?.profile_pic && (
                <img
                  src={trustData?.profile_pic}
                  alt="Trust Logo"
                  className="h-14 mb-2"
                />
              )}
              {original ? "ORIGNIAL" : "DUPLICATE COPY"}
            </td>
            <td className="text-right text-sm font-semibold" colSpan={2}>
              Receipt No: {data?.receipt_number} <br />
              <span className="text-gray-600">
                Date Received: {data?.received_date}
              </span>
              <br />
              <span className="text-gray-600">
                Date Completed: {data?.transaction_date}
              </span>
            </td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td colSpan={3} className="text-center p-4">
              <div className="text-lg font-semibold">Trust Account Receipt</div>
              <div className="text-sm text-gray-700">
                {value || data?.trust?.receipt_template ? (
                  <HtmlContent
                    html={value ? value : data?.trust?.receipt_template}
                  />
                ) : (
                  "Agents Financial Administration Act 2014"
                )}
                {/* <br /> */}
                {data?.trust?.business_name
                  ? data?.trust?.business_name
                  : data?.trust?.first_name
                    ? data?.trust?.first_name + " " + data?.trust?.last_name
                    : data?.trust?.last_name
                      ? data?.trust?.last_name
                      : value
                        ? "[Trust Name]"
                        : ""}{" "}
                {/* <br/>
                {organizationData?.organizationData?.license_number
                  ? `Licence no. ${organizationData?.organizationData?.license_number}`
                  : value
                  ? "[Licence No.]"
                  : ""} */}
              </div>
            </td>
          </tr>
          <tr>
            <td colSpan={3}>
              <span className="font-medium">
                {getModuleNamingBySlug(
                  organizationData?.organizationData,
                  "contacts",
                  "Customer",
                )}
                :{" "}
              </span>
              {/* {data?.contact?.first_name
                ? data?.contact?.first_name + " " + data?.contact?.last_name
                : data?.contact?.last_name} */}
              {formatSubcontractorName(data?.contact)}
            </td>
            {/* <td colSpan={2}>
              {data?.contact?.first_name
                ? data?.contact?.first_name + " " + data?.contact?.last_name
                : data?.contact?.last_name}
            </td> */}
          </tr>
          <tr>
            <td colSpan={3}>
              <span className="font-medium">Payment method: </span>
              {data?.payment_method == "5"
                ? "JE"
                : paymentMethods?.find(
                    (item) => item.value === Number(data?.payment_method),
                  )?.label}
            </td>
            {/* <td colSpan={2}>
              {data?.payment_method == "5"
                ? "JE"
                : paymentMethods?.find(
                    (item) => item.value === Number(data?.payment_method)
                  )?.label}
            </td> */}
          </tr>
          {/* <tr>
            <td className="font-medium">Vendor:</td>
            <td colSpan={2}>{formatSubcontractorName(data?.vendor)}</td>
          </tr>
          
          <tr>
            <td className="font-medium">Asset:</td>
            <td colSpan={2}>{data?.asset?.name}</td>
          </tr>
          <tr>
            <td className="font-medium">
              {getModuleNamingBySlug(
                organizationData?.organizationData,
                "sub-assets",
                "Sub Asset"
              )}
              :
            </td>
            <td colSpan={2}>{data?.sub_asset?.name}</td>
          </tr>
          <tr>
            <td className="font-medium">Description:</td>
            <td colSpan={2}>{data?.description}</td>
          </tr> */}

          <tr>
            <td colSpan={3}>
              <table className="w-full border-none  border-collapse mt-4 text-xs ">
                <thead>
                  <tr className="border-b font-bold">
                    <td className="p-2">
                      {getModuleNamingBySlug(
                        organizationData?.organizationData,
                        "sub-assets",
                        "Sub Asset",
                      )}
                    </td>
                    <td className="p-2">
                      {LawyerConditon(organizationData)
                        ? "Matter Description"
                        : "Description"}
                    </td>
                    <td className="p-2 text-right">Amount (Inc)</td>
                  </tr>
                </thead>
                <tbody>
                  {data?.receipt_detail?.map((item, idx) => (
                    <tr key={idx} className="border-b ">
                      <td className="p-2">{item.sub_asset?.name}</td>
                      <td className="p-2">{item.description}</td>
                      <td className="p-2 text-right">
                        ${formatNumber(Number(item.amount))}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </td>
          </tr>
          <tr>
            {/* <td className="font-medium">The sum of:</td>
            <td colSpan={2}>{`$${formatNumber(
              Number(data?.total_amount)
            )}`}</td> */}
            <td colSpan={3}>
              <span className="font-medium">The sum of: </span>
              {`$${formatNumber(Number(data?.amount))}`}
            </td>
          </tr>

          <tr>
            <td colSpan={2}>
              Completed by:{" "}
              {trustData?.business_name
                ? trustData?.business_name
                : trustData?.first_name
                  ? trustData?.first_name + " " + trustData?.last_name
                  : trustData?.last_name}
            </td>
            <td className="text-right">Signature: ____________</td>
          </tr>
        </tbody>
      </table>
    ) : (
      <div className="border border-gray-400 p-6 text-sm w-full leading-relaxed">
        {/* Header */}
        <div className="text-center font-bold mb-4">
          {data?.trust?.business_name
            ? data?.trust?.business_name
            : data?.trust?.first_name
              ? data?.trust?.first_name + " " + data?.trust?.last_name
              : data?.trust?.last_name
                ? data?.trust?.last_name
                : value
                  ? "[Trust Name]"
                  : ""}{" "}
          <br />
          TRUST ACCOUNT RECEIPT
          <br />
          {value || data?.trust?.receipt_template ? (
            <HtmlContent html={value ? value : data?.trust?.receipt_template} />
          ) : (
            "Agents Financial Administration Act 2014"
          )}
        </div>

        {/* Receipt Number / Date */}
        <div className="grid grid-cols-2 gap-4">
          <div>
            <span className="font-medium">Receipt Number:</span>
            <span className="inline-block border-b border-black w-48 ml-2">
              {data?.receipt_number || <>&nbsp;</>}
            </span>
          </div>
        </div>
        <div className="grid grid-cols-2 gap-4 mt-4">
          <div>
            <span className="font-medium">Date: </span>
            <span className="inline-block border-b border-black w-48">
              {data?.transaction_date ? data?.transaction_date : <>&nbsp;</>}
            </span>
          </div>
          <div>
            <span className="font-medium">Date Received (if different):</span>
            <span className="inline-block border-b border-black w-32 ml-2">
              {data?.received_date ? data?.received_date : <>&nbsp;</>}
            </span>
          </div>
        </div>

        {/* Received From */}
        <div className="mt-4">
          <span className="font-medium">Received from:</span>
          <span className="inline-block border-b border-black w-[80%] ml-2">
            {formatSubcontractorName(data?.contact)}
          </span>
        </div>

        {/* Sum */}
        <div className="mt-4 flex items-center">
          <span className="font-medium">The sum of:</span>
          <span className="inline-block border-b border-black w-64 ml-2">
            ${dollars}
          </span>
          <span className="ml-2">and</span>
          <span className="inline-block border-b border-black w-40 ml-2">
            {cents}
          </span>
          <span className="ml-2">cents.</span>
        </div>

        {/* Amount Line */}
        <div className="mt-4 flex items-center">
          <span className="inline-block border-b border-black w-64 ml-2">
            ${formatNumber(Number(data?.amount))}
          </span>
          <span className="ml-4">
            {data?.payment_method == "5"
              ? "JE"
              : paymentMethods?.find(
                  (item) => item.value === Number(data?.payment_method),
                )?.label}
          </span>
        </div>

        {/* Matter Details */}
        <div className="mt-6">
          <div className="font-medium">For and on behalf of:</div>

          <div className="grid grid-cols-2 gap-4 mt-2">
            <div>
              <span className="font-medium">
                {LawyerConditon(organizationData)
                  ? "Matter Reference"
                  : "File Note"}
              </span>
              <span className="inline-block border-b border-black w-full">
                {data?.file_note ? data?.file_note : <>&nbsp;</>}
              </span>
            </div>

            <div>
              <span className="font-medium">Account Name</span>
              <span className="inline-block border-b border-black w-full">
                {data?.contact?.account_name ? (
                  data?.contact?.account_name
                ) : (
                  <>&nbsp;</>
                )}
              </span>
            </div>

            {/* <div>
              <span className="font-medium">Matter Description</span>
              <span className="inline-block border-b border-black w-full">
                {data?.description}
              </span>
            </div> */}
          </div>

          <table className="w-full border-none  border-collapse mt-4">
            <thead>
              <tr className="border-b border-black font-medium">
                <td className="p-2">
                  {getModuleNamingBySlug(
                    organizationData?.organizationData,
                    "sub-assets",
                    "Sub Asset",
                  )}
                </td>
                <td className="p-2">
                  {LawyerConditon(organizationData)
                    ? "Matter Description"
                    : "Description"}
                </td>
                <td className="p-2 text-right">Amount (Inc)</td>
              </tr>
            </thead>
            <tbody>
              {data?.receipt_detail?.map((item, idx) => (
                <tr key={idx} className="border-b border-black">
                  <td className="p-2">{item.sub_asset?.name}</td>
                  <td className="p-2">{item.description}</td>
                  <td className="p-2 text-right">
                    ${formatNumber(Number(item.amount))}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Reason */}
        {/* <div className="mt-6">
          <span className="font-medium">Reason:</span>
          <span className="inline-block border-b border-black w-[85%] ml-2">
            {data?.reason}
          </span>
        </div> */}

        {/* Footer */}
        <div className="mt-10 gridgrid-cols-1">
          <div className="text-right">
            <span className="font-medium">Made out by:</span>
            <span className="inline-block border-b border-black w-48 ml-2 text-left">
              {data?.trust?.business_name
                ? data?.trust?.business_name
                : data?.trust?.first_name
                  ? data?.trust?.first_name + " " + data?.trust?.last_name
                  : data?.trust?.last_name
                    ? data?.trust?.last_name
                    : "[Trust Name]"}
            </span>
          </div>

          <div className="text-right pr-4">
            On behalf of{" "}
            <span className="inline-block w-48 text-left mt-2">
              {data?.trust?.business_name
                ? data?.trust?.business_name
                : data?.trust?.first_name
                  ? data?.trust?.first_name + " " + data?.trust?.last_name
                  : data?.trust?.last_name
                    ? data?.trust?.last_name
                    : "[Trust Name]"}
            </span>
          </div>
        </div>
      </div>
    );
  };

  return (
    <ResponsiveDrawerForm
      title="Receipt Details"
      open={showView}
      setOpen={setShowView}
      read
      popupType={popupType}
      className={compact ? "md:w-[65vw]" : "md:w-[90vw]"}
    >
      <>
        <div className="flex items-center justify-center space-x-2">
          <span
            className="text-sm font-medium cursor-pointer"
            onClick={() => {
              setCompact(false);
            }}
          >
            Detailed View
          </span>
          <Switch
            checked={compact}
            onCheckedChange={(e) => {
              if (e === true) {
                setCompact(true);
              } else {
                setCompact(false);
              }
            }}
            className="data-[state=checked]:bg-webPrimary"
          />
          <span
            className="text-sm font-medium cursor-pointer"
            onClick={() => {
              setCompact(true);
            }}
          >
            Compact View
          </span>
        </div>
        {compact ? (
          <>
            <div className="p-6 max-h-[80vh] overflow-y-auto">
              {/* 👇 Print & Preview Content (SAME DIV) */}
              <div className="rounded-md border">
                <div
                  ref={printRef}
                  className="bg-white text-black p-4 max-w-4xl mx-auto text-sm m-0"
                >
                  {htmlData(true)}
                  <hr className="m-4" />
                  {htmlData(false)}
                </div>
              </div>
            </div>
            {/* 👇 Print Button */}
            <div className="mt-4 flex justify-end">
              <Button onClick={handlePrint}>Print</Button>
            </div>
          </>
        ) : (
          <>
            <div className="form-box flex max-h-[78vh] bg-muted flex-col gap-4 overflow-y-auto overflow-x-hidden p-2 border rounded-lg">
              <div className="border bg-background rounded-md p-2 shadow-sm space-y-2 flex w-full items-center flex-wrap relative">
                <div className="grid lg:grid-cols-8 sm:grid-cols-2 gap-4 w-full">
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText labelText="Received Date" />
                    </Label>
                    <DisplayInput value={values?.received_date} />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText labelText="Transaction Date" />
                    </Label>
                    <DisplayInput value={values?.transaction_date} />
                  </div>
                  <div className="grid gap-2">
                    <Label htmlFor="file_note">
                      <CustomLabelText
                        labelText={
                          LawyerConditon(organizationData)
                            ? "Matter Reference"
                            : "File Note"
                        }
                        bottomAlign={true}
                      />
                    </Label>
                    <DisplayInput
                      value={values?.file_note ? values?.file_note : ""}
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="invoice_number">
                      <CustomLabelText
                        labelText="Invoice Number"
                        bottomAlign={true}
                      />
                    </Label>
                    <DisplayInput
                      value={
                        values?.invoice_number ? values?.invoice_number : ""
                      }
                    />
                  </div>

                  <div className="grid gap-2">
                    <Label htmlFor="payeer">
                      <CustomLabelText labelText="Payer" />
                    </Label>

                    <DisplayInput
                      value={
                        values?.payeer == "1"
                          ? getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "vendors",
                              "Vendor",
                            )
                          : getModuleNamingBySlug(
                              organizationData?.organizationData,
                              "contacts",
                              "Customer",
                            )
                      }
                    />
                  </div>

                  {values?.payeer == "1" ? (
                    <div className="grid gap-2">
                      <Label htmlFor="vendor_id">
                        <CustomLabelText
                          labelText={getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "vendors",
                            "Vendor",
                          )}
                        />
                      </Label>

                      <DisplayInput
                        value={
                          values?.vendor_id
                            ? `${formatSubcontractorName(values?.vendor)}${
                                values?.vendor?.code
                                  ? ` (${values?.vendor?.code})`
                                  : ""
                              }`
                            : ""
                        }
                      />
                    </div>
                  ) : (
                    <div className="grid gap-2">
                      <Label htmlFor="contact_id">
                        <CustomLabelText
                          labelText={getModuleNamingBySlug(
                            organizationData?.organizationData,
                            "contacts",
                            "Customer",
                          )}
                        />
                      </Label>
                      <DisplayInput
                        value={
                          values?.contact
                            ? `${formatSubcontractorName(values?.contact)}${
                                values?.contact?.code
                                  ? ` (${values?.contact?.code})`
                                  : ""
                              }`
                            : ""
                        }
                      />
                    </div>
                  )}

                  <div className="grid gap-2">
                    <Label htmlFor="base_type">
                      <CustomLabelText
                        required={true}
                        labelText="Payment Method"
                      />
                    </Label>

                    <DisplayInput
                      value={
                        values?.payment_method
                          ? paymentMethods?.find(
                              (item) => item.value == values?.payment_method,
                            )?.label
                          : ""
                      }
                      readonly
                    />
                  </div>
                  <div className="grid gap-2">
                    <div className="min-w-0">
                      <div className="relative mt-7">
                        <div className="flex items-center space-x-2 mt-4">
                          <Checkbox
                            id="terms"
                            checked={values?.refund ? true : false}
                            name="refund"
                          />
                          <label
                            htmlFor="terms"
                            className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70 flex items-center gap-2"
                          >
                            Refundable Deposit
                            <CustomTooltip
                              message={
                                "General ledger entry will be posted to customer account"
                              }
                              rightAlign={true}
                            >
                              <InfoCircledIcon className="text-webPrimary" />
                            </CustomTooltip>
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="bg-webPrimary text-white text-sm px-2 rounded-md absolute top-0 right-2">
                  Receipt Total: $
                  {formatNumber(
                    Number(`${values?.original_amount}`.replace(/,/g, "")),
                  )}
                </div>
              </div>
              <>
                {values?.receipt_detail.map((receipt, pIndex) => (
                  <div className="border bg-background rounded-md p-2 shadow-sm space-y-2">
                    <div className="flex justify-between items-center">
                      <h4 className="font-semibold">Receipt</h4>
                    </div>

                    <div className="grid lg:grid-cols-5 sm:grid-cols-2 gap-4">
                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="sub_asset_id">
                            <CustomLabelText
                              labelText={getModuleNamingBySlug(
                                organizationData?.organizationData,
                                "sub-assets",
                                "Sub Asset",
                              )}
                            />
                          </Label>
                          <div className="mt-2 relative">
                            <DisplayInput
                              value={
                                receipt?.sub_asset_id
                                  ? `${receipt?.sub_asset?.name}${
                                      receipt?.sub_asset?.identifier
                                        ? ` (${receipt?.sub_asset?.identifier})`
                                        : ""
                                    }`
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="asset_id">
                            <CustomLabelText
                              labelText={getModuleNamingBySlug(
                                organizationData?.organizationData,
                                "assets",
                                "Asset",
                              )}
                            />
                          </Label>
                          <div className="mt-2 relative">
                            <DisplayInput
                              value={
                                receipt?.asset_id ? receipt?.asset?.name : ""
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="vendor_id">
                            <CustomLabelText
                              labelText={getModuleNamingBySlug(
                                organizationData?.organizationData,
                                "vendors",
                                "Vendor",
                              )}
                              required={true}
                            />
                          </Label>
                          <div className="relative mt-2">
                            <DisplayInput
                              value={
                                receipt?.vendor_id
                                  ? `${formatSubcontractorName(receipt?.vendor)}${
                                      receipt?.vendor?.code
                                        ? ` (${receipt?.vendor?.code})`
                                        : ""
                                    }`
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>

                      <div className="grid gap-2">
                        <div className="min-w-0">
                          <Label htmlFor="contract_id">
                            <CustomLabelText labelText="Agreement/Contract" />
                          </Label>
                          <div className="relative mt-2">
                            <DisplayInput
                              value={
                                receipt?.contract_id
                                  ? receipt?.contract?.contract_number
                                  : ""
                              }
                            />
                          </div>
                        </div>
                      </div>

                      {receipt?.sub_asset_id && (
                        <div className="grid gap-2">
                          <div className="min-w-0">
                            <Label htmlFor="gst">
                              <CustomLabelText labelText="GST/VAT Applicable" />
                            </Label>
                            <div className="relative mt-2">
                              <DisplayInput
                                value={receipt?.tax == "1" ? "Yes" : "No"}
                              />
                            </div>
                          </div>
                        </div>
                      )}

                      {!LawyerConditon(organizationData) && (
                        <>
                          {" "}
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="ts_job_id">
                                <CustomLabelText labelText="Job/Matter" />
                              </Label>
                              <div className="relative mt-2">
                                <DisplayInput
                                  value={
                                    receipt?.ts_job_id
                                      ? receipt?.ts_job?.code
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </div>
                          <div className="grid gap-2">
                            <div className="min-w-0">
                              <Label htmlFor="ts_task_id">
                                <CustomLabelText labelText="Task/Milestone" />
                              </Label>
                              <div className="relative mt-2">
                                <DisplayInput
                                  value={
                                    receipt?.ts_task_id
                                      ? receipt?.ts_task?.code
                                      : ""
                                  }
                                />
                              </div>
                            </div>
                          </div>
                        </>
                      )}
                    </div>

                    <>
                      <div className="flex items-center justify-between mt-4">
                        <h5 className="font-medium text-sm">Receipt Rows</h5>
                      </div>

                      <div className="relative">
                        <div
                          className={`grid sm:grid-cols-2 grid-cols-1 gap-4 items-start !mt-4 lg:grid-cols-7`}
                        >
                          <div className="grid gap-2">
                            <Label>
                              <CustomLabelText labelText="From" />
                            </Label>

                            <DisplayInput
                              value={receipt?.from ? receipt?.from : ""}
                            />
                          </div>
                          <div className="grid gap-2">
                            <Label>
                              <CustomLabelText labelText="To" />
                            </Label>

                            <DisplayInput
                              value={receipt?.to ? receipt?.to : ""}
                            />
                          </div>

                          <div className="grid gap-2">
                            <Label>
                              <CustomLabelText labelText="Amount (Inc)" />
                            </Label>

                            <DisplayInput
                              value={receipt?.amount ? receipt?.amount : ""}
                            />
                          </div>

                          <div className="grid gap-2">
                            <Label>
                              <CustomLabelText labelText="Amount (Exc)" />
                            </Label>

                            <DisplayInput
                              value={
                                receipt?.amount_exc ? receipt?.amount_exc : ""
                              }
                            />
                          </div>

                          <div className="grid gap-2">
                            <Label>
                              <CustomLabelText
                                labelText={`Tax(${
                                  receipt?.tax === "1"
                                    ? receipt?.sub_asset?.tax_percentage
                                      ? receipt?.sub_asset?.tax_percentage
                                      : 0
                                    : 0
                                }%)`}
                              />
                            </Label>

                            <DisplayInput
                              value={
                                receipt?.tax_amount ? receipt?.tax_amount : ""
                              }
                            />
                          </div>
                          <div className="flex gap-2 sm:col-span-2">
                            <div className="grid gap-2 flex-1">
                              <Label>
                                <CustomLabelText
                                  labelText={
                                    LawyerConditon(organizationData)
                                      ? "Matter Description"
                                      : "Description"
                                  }
                                />
                              </Label>
                              <DisplayInput
                                value={
                                  receipt?.description
                                    ? receipt?.description
                                    : ""
                                }
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </>
                  </div>
                ))}
              </>
            </div>
          </>
        )}
      </>
    </ResponsiveDrawerForm>
  );
};

export default ReceiptDetailsPopup;
